import { render } from "./BasePlayer.vue?vue&type=template&id=3fd7ad22&scoped=true"
import script from "./BasePlayer.vue?vue&type=script&lang=js"
export * from "./BasePlayer.vue?vue&type=script&lang=js"

import "./BasePlayer.vue?vue&type=style&index=0&id=3fd7ad22&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd7ad22"]])

export default __exports__